export enum StudentTicketPaymentStatus {

  EXTERNAL = "EXTERNAL",
  PENDING = "PENDING",
  OVERPAID = "OVERPAID",
  UNDERPAID = "UNDERPAID",
  PAID = "PAID"

}
